import {
  UPDATE_THEME_DATA,
  UPDATE_THEME_DATA_SUCCESS,
  UPDATE_THEME_DATA_FAILURE,
  FETCH_THEME_DATA,
  FETCH_THEME_DATA_SUCESS,
  FETCH_THEME_DATA_FAILURE,
  SET_THEME_DATA,
  SAVE_THEME_DATA,
  GET_THEME_DATA,
  GET_ALL_THEME_DATA,
  GET_ALL_THEME_DATA_SUCCESS,
  GET_ALL_THEME_DATA_FAILURE,
  FETCH_ACTIVE_THEME_ID,
  RESET_THEME_DATA,
  DELETE_THEME_DATA,
  UPDATE_THEME_ERROR,
  UPDATE_FETCH_THEME_LOADER,
} from "./constants";
import {
  IAllThemeDataPayload,
  IDeleteThemeDataPayload,
  IFetchActiveThemeData,
  IGetAllThemeDataPayload,
  IsaveThemeDataPayload,
  IThemeErrorPayload,
  IThemeInitalState,
} from "./interface";
// import { IThemeInitalState } from "./interface";

export const updateThemeData = (payload: any) => {
  return {
    type: UPDATE_THEME_DATA,
    payload,
  };
};
export const updateThemeDataSucess = (payload: IThemeInitalState) => {
  return { type: UPDATE_THEME_DATA_SUCCESS, payload };
};
export const updateThemeDataFailure = () => {
  return { type: UPDATE_THEME_DATA_FAILURE };
};

export const saveThemeData = (payload: IsaveThemeDataPayload) => {
  return { type: SAVE_THEME_DATA, payload };
};

export const getAllThemeData = (payload: IGetAllThemeDataPayload) => {
  return { type: GET_ALL_THEME_DATA, payload };
};

export const getAllThemeDataSuccess = (payload: IAllThemeDataPayload[]) => {
  return { type: GET_ALL_THEME_DATA_SUCCESS, payload };
};

export const getAllThemeDataFailure = () => {
  return { type: GET_ALL_THEME_DATA_FAILURE };
};

export const fetchActiveTheme = (payload: IFetchActiveThemeData) => {
  return { type: FETCH_ACTIVE_THEME_ID, payload };
};
export const resetThemeData = () => {
  return { type: RESET_THEME_DATA };
};
export const deleteThemeData = (payload: IDeleteThemeDataPayload) => {
  return { type: DELETE_THEME_DATA, payload };
};
export const updateThemeError = (payload: IThemeErrorPayload) => {
  return { type: UPDATE_THEME_ERROR, payload };
};
export const updateFetchThemeLoader = () => {
  return { type: UPDATE_FETCH_THEME_LOADER };
};
